/**
 * Route for `criteo-integration`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CriteoIntegrationPage } from "../features/criteo-integration/CriteoIntegrationPage";

export const criteoIntegrationRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/criteo-integration",
	component: CriteoIntegrationPage,
});

export default criteoIntegrationRoute;
